import React from "react";
import StyledHeader from "../../components/StyledHeader";
import unauth from "../../../public/images/svg/errorCaution.svg";
import { ACCESS_DENIED_DESCRIPTION, ACCESS_DENIED_TITLE } from "@/constants";

const NoAccessPage = () => {
  return (
    <>
      <StyledHeader />
      <div className="pt-8 text-blue-600 justify-center text-center">
        <div className="mx-auto max-w-xl">
          <div className="tracking-widest mt-4">
            <div className="pb-5">
              <div className="flex justify-center items-center pt-20 pb-5">
                <img className="w-[100px]" src={unauth} alt="unauth" />
              </div>
            </div>
            <span className="text-4xl block">{ACCESS_DENIED_TITLE}</span>
            <span className="mt-6 text-xl block max-w-lg mx-auto">
              {ACCESS_DENIED_DESCRIPTION}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoAccessPage;
